import { fromTradingViewResolution } from '@talos/kyoko';
import type { LayoutSection } from '../../types/LayoutConfig';
import type { AppConfigStateWithLegacyLayoutConfigs } from './AppConfigMigrations/legacyLayoutConfigs.types';

/**
 * Converts legacy TradingView chart resolution format to the new format.
 * E.g. '60' -> '1H', '1' -> '1M', '5' -> '5M', '240' -> '4H'
 */
function convertChartResolution(resolution: string | undefined): string | undefined {
  if (resolution == null) {
    return resolution;
  }

  return fromTradingViewResolution(resolution);
}

/** `layoutConfigs` exists only during `replaceLegacyConfig` before migration to `spacesConfigs.layouts`. */
export function replaceLegacyPriceChartConfig(appConfigState: AppConfigStateWithLegacyLayoutConfigs) {
  const layoutConfigs = appConfigState.layoutConfigs;
  if (layoutConfigs == null) {
    return;
  }

  // Iterate over each section in the layout configs
  for (const section in layoutConfigs) {
    // Iterate over each panel in the section
    for (const layoutConfigId in layoutConfigs[section as LayoutSection]) {
      const layoutConfig = layoutConfigs[section as LayoutSection]?.[layoutConfigId];

      if (layoutConfig?.dockViewLayout?.panels == null) {
        continue;
      }

      // Iterate over each panel in the layout config
      for (const panelId in layoutConfig.dockViewLayout.panels) {
        const panel = layoutConfig.dockViewLayout.panels[panelId];

        // If the panel has type 'tradingViewChart', replace the type and chartResolution
        if (panel.contentComponent === 'tradingViewChart') {
          panel.contentComponent = 'historicalPriceChart';
          if (panel.params != null) {
            panel.params.type = 'historicalPriceChart';
            panel.params.chartResolution = convertChartResolution(panel.params.chartResolution);
          }
        }
        // If the panel has type 'deepDive', just replace the chartResolution
        if (panel.contentComponent === 'deepDive') {
          if (panel.params != null) {
            panel.params.chartResolution = convertChartResolution(panel.params.chartResolution);
          }
        }
      }
    }
  }
}
